import { styled } from "@mui/material/styles";

export const StyledForm = styled("form")`
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
